import { useReducer, useCallback } from "react";
import loginReducer, { initialState } from "./reducer";
import { loginRequest, loginSuccess, loginFailure, logout } from "./actions";
import { loginUser } from "./api";
import { jwtDecode } from "jwt-decode";
import { setCookie, eraseCookie, getCookie } from "../../../lib/utils/cookieUtil";
import {
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
  LOCAL_STORAGE_KEYS,
} from "../../../lib/utils/localStorageUtil";

export default function useAuth() {
  function getHydratedState() {
    let user = getLocalStorage(LOCAL_STORAGE_KEYS.USER_DETAILS);
    let sessionExpired = true;
    let managerToken = getCookie("manager_token");
    let system_id = getCookie("system_id");
    let exp = null;
    if (managerToken) {
      try {
        const decoded = jwtDecode(managerToken);
        exp = decoded.exp;
        user = decoded.data || user;
        if (exp && Date.now() / 1000 < exp) {
          sessionExpired = false;
        }
      } catch (e) {
        console.error("JWT decode error:", e);
      }
    }
    return {
      ...initialState,
      user: user || null,
      sessionExpired,
      system_id,
    };
  }

  const [state, dispatch] = useReducer(loginReducer, getHydratedState());

  const doLogin = useCallback(async credentials => {
    dispatch(loginRequest());
    try {
      if (credentials) {
        const { email, password } = credentials;
        if (email === "admin@email.com" && password === "admin") {
          const fakeData = {
            session_id: "local-dev-session",
            manager_token: null,
            system_id: "local-system",
            user: { email: "admin", role: "admin" },
          };
          setCookie("session_id", fakeData.session_id, null);
          setCookie("system_id", fakeData.system_id, null);
          setLocalStorage(LOCAL_STORAGE_KEYS.USER_DETAILS, fakeData.user);
          dispatch(loginSuccess({ ...fakeData }));
          return fakeData;
        }
      }
      const response = await loginUser(credentials);
      setCookie("session_id", response.session_id, null);
      setCookie("manager_token", response.manager_token, null);
      setCookie("system_id", response.system_id, null);
      let user = {};
      let exp = null;
      if (response.manager_token) {
        try {
          const decoded = jwtDecode(response.manager_token);
          user = decoded.data || {};
          exp = decoded.exp;
        } catch (e) {
          /* empty */
        }
      }
      setLocalStorage(LOCAL_STORAGE_KEYS.USER_DETAILS, user);
      dispatch(loginSuccess({ ...response, ...user, exp }));
      return response;
    } catch (error) {
      dispatch(loginFailure(error.response?.data || error.message));
      throw error;
    }
  }, []);

  const doLogout = useCallback(() => {
    eraseCookie("session_id");
    eraseCookie("manager_token");
    eraseCookie("system_id");
    removeLocalStorage(LOCAL_STORAGE_KEYS.USER_DETAILS);
    dispatch(logout());
    window.location.href = "/login";
  }, []);

  return {
    ...state,
    login: doLogin,
    logout: doLogout,
  };
}
